import Axios from "../config/Axios";

export const ApiCrearComida = async (data) => {
  try {
    const result = await Axios.post(`/POSTcreateComida`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiEditarComida = async (data) => {
  try {
    const result = await Axios.post(`/POSTeditComida`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiActivarDesactivarComida = async (data) => {
  try {
    const result = await Axios.post(`/POSTtoggleEstadoComida`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiDeleteComida = async (pre_comida_id) => {
  try {
    const result = await Axios.post(`/POSTdeleteComida`, pre_comida_id);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetAllComidas = async (data) => {
  try {
    const result = await Axios.get(`/GETallComidas`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetDataComida = async (pre_comida_id) => {
  try {
    const result = await Axios.get(`/GETdataComida/${pre_comida_id}`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiUpdateMenuComida = async (data) => {
  try {
    const result = await Axios.post(`/POSTMenuComida`, data);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};

export const ApiGetAllComidasToday = async () => {
  try {
    const result = await Axios.get(`/GETallComidasToday`);
    return result.data;
  } catch (e) {
    return [
      {
        sms: "err",
        data: [],
        mensaje: e,
      },
    ];
  }
};
